import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
} from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ProductWithSpend } from '../grid-column-definitions/grid-products-column-definitions.service';

@Component({
    template: `
    <span>
      <!-- Cross status - e.g. "not crossed", "crossed" -->
      <div
        class="custom-line-height-cell {{ textClass }}"
        data-test-selector="cross-type-desc"
      >
        {{ value }}
      </div>
      <!-- Seller name -->
      <div
        class="cell-wrap-text text-truncate custom-line-height-cell"
        data-test-selector="cross-type-desc-org-name"
      >
        {{ createdBy }}
      </div>
    </span>
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CrossReferenceTypeCellRendererComponent
  implements ICellRendererAngularComp
{
  constructor(private changeDetectorRef: ChangeDetectorRef) {}
  value?: unknown;
  createdBy!: string;
  textClass!: string;

  agInit({ value, data }: ICellRendererParams<ProductWithSpend, string>): void {
    if (value) this.value = value;

    this.createdBy = data?.bestCross ? data.bestCross.createdByOrg.name : '';
    if (data?.bestCross?.createdByOrgType === 'SELLER') {
      this.createdBy = '';
    }
    if (value === 'Not Crossed') {
      this.textClass = 'text-muted';
    }
    this.changeDetectorRef.detectChanges();
  }

  refresh(): boolean {
    return false;
  }
}
